import React from "react";
import { Check } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useConversion } from "@/context/ConversionContext";
import { Reveal, Eyebrow } from "@/components/common/Section";

export default function Difference() {
  const { t } = useLang();
  const { openForm } = useConversion();
  return (
    <section className="bg-nek-navy py-20 sm:py-28" data-testid="difference-section">
      <div className="nek-container">
        <Reveal className="max-w-3xl">
          <Eyebrow className="!text-nek-teal-100">{t.diff.eyebrow}</Eyebrow>
          <h2 className="nek-h2 mt-4 text-white">{t.diff.title}</h2>
          <p className="mt-6 text-lg leading-relaxed text-white/70">{t.diff.text}</p>
        </Reveal>
        <Reveal className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {t.diff.pills.map((pill) => (
            <div key={pill} className="flex items-center gap-3 rounded-xl border border-white/10 bg-white/5 px-4 py-4">
              <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-nek-blue text-white">
                <Check className="h-4 w-4" strokeWidth={3} />
              </span>
              <span className="text-sm font-medium text-white">{pill}</span>
            </div>
          ))}
        </Reveal>
        <Reveal className="mt-10">
          <button type="button" onClick={() => openForm({ need: t.form.needs[12] })} data-testid="diff-cta" className="btn-coral">
            {t.cta.presentSituation}
          </button>
        </Reveal>
      </div>
    </section>
  );
}
